<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')" prop="status">
              <Select v-model="pageParams.status" transfer filterable>
                <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                style="width:100%"
                type="datetimerange"
                :transfer="true"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="timeValue">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col style="min-width: 200px;">
            <Button @click="reset" v-once icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="ios-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('wmsPickupOrder_exportWmsPickupOrderExcel')">
      <Dropdown transfer @on-click="changeExportBtn">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        :loading="tableLoading"
        max-height="520"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003082')"
      paramKeyColums="wmsPickupOrderExport"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--打印箱唛-->
    <printCaseMarkModal
      ref="printTalg"
      :apiUrl="apiUrl"
      service="yms-supplier-service"
      typeTalg="packingManage">
    </printCaseMarkModal>
    <!--修改物流信息弹窗-->
    <logisticsInfoModal ref="logisticsInfo" @updateData="pageParamsStatus = true"></logisticsInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import printCaseMarkModal from "@/components/common/printCaseMarkModal.vue";
import logisticsInfoModal from "@/components/common/logisticsInfoModal.vue";
import {getBelongingWarehouseData, getDataSetBatchList, getEnumList, getWarehouseName,
  jumpToTheCourierInquiry, pageJump, setConfigCharacters, getEnumName} from "@/utils/common";
import dropDownFilter from "@/components/common/dropDownFilter.vue";

export default {
  name: "shipmentRecord",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        status: 'null', // 0:正在装箱，1:等待揽收，2:已揽收，3.YMS已收货
        wmsPickupOrderNumbers: null,
        thirdPickupOrderNumbers: null,
        packageCodes: null,
        createdStartTime: null,
        createdEndTime: null,
        upDown: 'down',
        orderBy: 'createdTime',
        pageNum: 1,
        pageSize: 15
      },
      selectTableData: [],
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658'),
          key: 'pickupOrderNumber',
          align: 'center',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let statusTxt = '-';
            let status = params.row.status;
            let content = params.row.invalidReason;
            v.statusList.map((item) => {
              if (item.value === status) {
                statusTxt = item.title;
              }
            });
            return h('div', {class: 'flex align-items-center'}, [
              h('span', statusTxt),
              status === 99 ? h('Tooltip', {
                props: {
                  transfer: true,
                  content: content,
                  maxWidth: 300,
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  class: 'ml3 cursor',
                  props: {
                    type: 'md-help-circle',
                    size: 17,
                    color: '#7F7F7F'
                  },
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867'),
          key: 'deliveryMethod',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let text = '';
            if (deliveryType === 1) {
              let name = getEnumName(v.enumData, 'TransportTypeEnum', transportType, 'number');
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}` + ' ' + '-' + ' ' + name;
            } else {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let expressageNo = params.row.expressageNo;
            let expressageCode = params.row.expressageCode;
            let trackingNumber = params.row.trackingNumber;
            return h('div', [
              deliveryType === 1 && transportType === 2 ? h('span', `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`) :
                h('div', [
                  h('div', {class: 'mt10'}, ''),
                  h('Alink', {
                    props: {
                      linkName: expressageNo,
                      Aicon: '&#xe6e7;',
                      AlinkShow: false,
                      AiconSize: '22px',
                      AiconShow: expressageCode ? true : false,
                      AiconColor: '#2D8CF0',
                      styles: {
                        justifyContent: 'center'
                      }
                    },
                    on: {
                      AIconBtn: () => {
                        jumpToTheCourierInquiry(expressageCode, expressageNo, trackingNumber);
                      }
                    }
                  })
                ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004957'),
          key: 'totalQuantities',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006816'),
          key: 'totalActualSortingNumber',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let totalQuantities = params.row.totalQuantities;
            let totalActualSortingNumber = params.row.totalActualSortingNumber;
            let talg = false;
            if (totalQuantities && totalActualSortingNumber && totalActualSortingNumber !== totalQuantities) {
              talg = true;
            }
            return h('span', {class: talg ? 'redColor' : ''}, totalActualSortingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006817'),
          key: 'totalSupplierOverSortingNumber',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let totalSupplierOverSortingNumber = params.row.totalSupplierOverSortingNumber || '-';
            return h('span', {class: totalSupplierOverSortingNumber !== '-' ? 'redColor' : ''}, totalSupplierOverSortingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let text = '-';
            let talg = false;
            let hasStockPackage = params.row.hasStockPackage; // 是否有多发补单 0 无 1 有
            let wmsPickupOrderId = params.row.wmsPickupOrderId;
            let status = params.row.status;
            let pickupOrderNumber = params.row.pickupOrderNumber;
            let ymsSortQuantities = params.row.ymsSortQuantities || 0;
            let totalQuantities = params.row.totalQuantities;
            if ((totalQuantities > 0 && totalQuantities !== ymsSortQuantities)
              || hasStockPackage === 1 || totalQuantities !== ymsSortQuantities) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004111');
              talg = true;
            }
            return status === 3 ? h('Alink', {
              props: {
                linkName: text,
                AlinkShow: talg,
                defineColor: talg ? '#FF3300' : '',
                styles: {
                  justifyContent: 'center'
                }
              },
              on: {
                AlinkBtn: () => {
                  v.$router.push({
                    path: '/shipmentRecordDetails',
                    query: {
                      pickupOrderNumber: pickupOrderNumber,
                      wmsPickupOrderId: wmsPickupOrderId
                    }
                  });
                }
              }
            }) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841'),
          key: 'logisticsCostCurrency',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let logisticsCostCurrency = params.row.logisticsCostCurrency;
            let logisticsCost = params.row.logisticsCost || '-';
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let text = '-';
            if (deliveryType === 1 && transportType === 1) {
              if (logisticsCost && logisticsCostCurrency) {
                text = logisticsCost + ' ' + logisticsCostCurrency;
              }
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675'),
          key: 'subsidyAmount',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let text = '-';
            let ruleName = params.row.ruleName;
            let auditStatus = params.row.auditStatus; // 1为待审核
            let subsidyAmount = params.row.subsidyAmount;
            let content = '';
            if (auditStatus === 1) {
              content = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006811')}`;
              text = '-';
            } else {
              if (subsidyAmount) {
                text = subsidyAmount + v.currencyState;
                if (ruleName) {
                  let list = ruleName.split(',');
                  if (list && list.length > 0) {
                    list.map((item) => {
                      item = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006812')}${item}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003842')}`;
                    });
                    content = list.join('、');
                  }
                }
              } else {
                content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006813')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006814')}`;
              }
            }
            return h('div', {class: 'flex justify-content-center align-items-center'}, [
              h('span', text),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 250,
                  placement: 'top',
                  content: content
                },
                style: {
                  marginLeft: '5px'
                }
              },
              [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17
                  },
                  style: {
                    cursor: 'pointer',
                    color: '#7F7F7F'
                  }
                })
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004106'),
          key: 'trackingMessage',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let trackingMessage = '-';
            if (deliveryType === 1 && transportType === 1) {
              trackingMessage = params.row.trackingMessage || '-';
            }
            return h('span', trackingMessage);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006818'),
          key: 'warehouseId',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.warehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          sortable: 'custom',
          sortType: 'desc',
          minWidth: 170,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.getDataToLocalTime(params.row.createdTime, 'fulltime') || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660'),
          key: 'pickupTime',
          sortable: 'custom',
          align: 'center',
          minWidth: 170,
          render: (h, params) => {
            return h('div', v.$uDate.getDataToLocalTime(params.row.pickupTime, 'fulltime') || '-');
          }
        },
        {
          title: ` ${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846')}`,
          key: 'ymsPickingDate',
          sortable: 'custom',
          align: 'center',
          minWidth: 170,
          render: (h, params) => {
            return h('div', v.$uDate.getDataToLocalTime(params.row.ymsPickingDate, 'fulltime') || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            let status = params.row.status;
            let pickupOrderNumber = params.row.pickupOrderNumber;
            let warehouseId = params.row.warehouseId;
            let wmsPickupOrderId = params.row.wmsPickupOrderId;
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('wmsPickupOrder_wmsPickupOrderDetail'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/shipmentRecordDetails',
                        query: {
                          pickupOrderNumber: pickupOrderNumber,
                          wmsPickupOrderId: wmsPickupOrderId
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001181'),
                    show: v.getPermission('wmsPickupOrder_printBoxShippingMark'),
                    clickFn: () => {
                      v.$refs['printTalg'].getPrintData(wmsPickupOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006819'),
                    show: status === 1 && v.getPermission('wmsPickupOrder_appendProductGoods'), // 等待揽收
                    clickFn: () => {
                      v.$router.push({
                        path: '/additionalGoods',
                        query: {
                          pickupOrderNumber: pickupOrderNumber,
                          warehouseId: warehouseId,
                          wmsPickupOrderId: wmsPickupOrderId,
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001573'), // 物流方式为自有物流且等待揽收状态
                    show: status === 1 && deliveryType === 2,
                    clickFn: () => {
                      v.$refs['logisticsInfo'].initLogisticsInfo(wmsPickupOrderId, 'shipmentRecord');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006820'),
                    show: [0, 1].includes(status),
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006821'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006822'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006820'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.cancelBillBtn(wmsPickupOrderId);
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      total: 0,
      timeValue: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'pickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775')},
            {paramKey: 'thirdPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006823')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461')},
            {paramKey: 'deliveryType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
            {paramKey: 'carrierId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220')},
            {paramKey: 'carrierCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006824')},
            {paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841')},
            {paramKey: 'subsidyAmount', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675')}`},
            {paramKey: 'ymsWarehouse', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390')},
            {paramKey: 'totalQuantities', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004957')},
            {paramKey: 'totalActualSortingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006816')},
            {paramKey: 'totalSupplierOverSortingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006817')},
            {paramKey: 'errorStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {paramKey: 'pickupTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660')},
            {paramKey: 'ymsPickingDate', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006815')}`},
            {paramKey: 'createdBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158')}
          ]
        }
      ],
      apiUrl: api.put_wmsPickupOrder_printBoxShippingMark,
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006825'), parameterKey: 'wmsPickupOrderNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004115'), parameterKey: 'thirdPickupOrderNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006826'), parameterKey: 'packageCodes'}
      ],
      defaultSelectValue: 1,
      warehouseList: [],
      enumData: [],
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 状态
    statusList() {
      const ENUM_KEY = 'WmsPickupOrderStatusSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.setDefaultTimerParams('three_months');
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList =['WmsPickupOrderStatusSupplierEnum', 'TransportTypeEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getBelongingWarehouseData(this.userInfo.merchantId).then((data) => {
          this.warehouseList = data;
        });
        await this.getList();
      })();
    },
    // 获取创建时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (value[0] !== '') {
          let timeList = v.defaultTimePeriod(value);
          v.timeValue = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置创建时间
    resetDate() {
      let v = this;
      v.pageParams.createdStartTime = null;
      v.pageParams.createdEndTime = null;
    },
    // 重置数据
    reset() {
      this.resetDate();
      this.timeValue = [];
      this.$refs['pageParams'].resetFields();
      this.setDefaultTimerParams('three_months');
      this.changeInput(1);
      this.search();
    },
    // 查询按钮
    search() {
      let v = this;
      v.pageParams.pageNum = 1;
      v.pageParamsStatus = true;
    },
    // 获取列表的数据
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('wmsPickupOrder_queryWmsPickupOrderList')) {
        v.tableLoading = true;
        v.axios.post(api.post_wmsPickupOrder_queryWmsPickupOrderList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.status = v.pageParams.status === 'null' ? null : v.pageParams.status;
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      data.map((item) => {
        if (item.pickupOrderNumber) {
          this.selectTableData.push(item.pickupOrderNumber);
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.wmsPickupOrderNumbers = v.selectTableData;
      } else {
        query.wmsPickupOrderNumbers = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_wmsPickupOrder_exportWmsPickupOrderExcel, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/supplier.html#/exportTask?operateCode=' + taskNumber, '/yms-supplier-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 创建时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 作废提单
    cancelBillBtn(wmsPickupOrderId) {
      let v = this;
      v.axios.post(api.post_wmsPickupOrder_invalid + wmsPickupOrderId, null, {
        loading: true,
        loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
      }).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006827'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
  },
  watch: {
    pageParamsStatus(n) {
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    logisticsInfoModal,
    exportFieldsModal,
    printCaseMarkModal
  }
};
</script>

<style scoped>

</style>
